import type { FC } from "react";
import { Text } from "@similarweb/ui-components/foundations";
import { colorsPalettes } from "@similarweb/styles";

interface IReportSectionTitleProps {
    title: string;
    dataAutomationKey: string;
}

export const ReportSectionTitle: FC<IReportSectionTitleProps> = ({
    title,
    dataAutomationKey,
}) => (
    <Text
        color={colorsPalettes.carbon[500]}
        fontVariant="h5"
        data-automation={`${dataAutomationKey}-title`}
        margin="8px 0 0 0"
    >
        {title}
    </Text>
);